<div class="card" (click)="onCardClick()">
  <div class="card-header">
    <h3 class="card-title">{{ cardData.title }}</h3>
    <svg-icon
      [name]="'maximize'"
      [svgStyle]="{ 'height.px': 16, 'width.px': 16 }"
    ></svg-icon>
  </div>
  <div class="card-image">
    <img [src]="cardData.image" [alt]="cardData.title" />
  </div>

  <p class="card-description">{{ cardData.description }}</p>

  <div class="card-tags">
    @for (tag of cardData.tags; track tag.label) {
      <span class="tag" [ngClass]="'tag-' + tag.color">
        {{ tag.label }}
      </span>
    }
  </div>
</div>
